import Application from "../../Application";
import withStore, {
  TLoadingAwarePresenter,
  TPresentable
} from "../../core/presenter/withStore";
import { IInstitutionDetails } from "../model/InstitutionDetails";
import { IOrganisation } from "../../organisations/model/Organisation";
import { IUser } from "../../user/model/User";
import { IDocumentType } from "../../documentTypes/model/DocumentType";

export interface TOrganisationDetailsHomePresenter
  extends TLoadingAwarePresenter {
  organisation: IOrganisation;
  institutionDetails: IInstitutionDetails;
  user?: IUser;
  caseLawDocumentTypes: IDocumentType[];
  caseDecisionTypes: IDocumentType[];
  legalViewTypes: IDocumentType[];
}

export interface IOrganisationDetailsHomePresenter
  extends TOrganisationDetailsHomePresenter,
    TPresentable {
  showCategories(id: number): void;

  loadReferenceValues(
    caseLawDocumentTypes: IDocumentType[],
    caseDecisionTypes: IDocumentType[],
    institutionDetails: IInstitutionDetails,
    legalViewTypes: IDocumentType[]
  ): void;
  loadOrganisation(organisation: IOrganisation): void;
  showAttachmentTypes(): void;
}

const defaultState: TOrganisationDetailsHomePresenter = {
  organisation: {} as IOrganisation,
  caseLawDocumentTypes: [],
  institutionDetails: {} as IInstitutionDetails,
  caseDecisionTypes: [],
  legalViewTypes: []
};

const OrganisationDetailsHomePresenter = withStore<
  IOrganisationDetailsHomePresenter,
  TOrganisationDetailsHomePresenter
>(
  ({
    application,
    store,
    loader,
    translate
  }): IOrganisationDetailsHomePresenter => {
    const _store = store;
    const _application: Application = application;
    const state = _store.getState<
      TOrganisationDetailsHomePresenter & TLoadingAwarePresenter
    >();
    const loadOrganisation = (organisation: IOrganisation) => {
      _store.update({
        organisation,
        breadCrumb: {
          id: () => organisation?.name
        }
      });
    };
    const loadReferenceValues = (
      caseLawDocumentTypes: IDocumentType[],
      caseDecisionTypes: IDocumentType[],
      institutionDetails: IInstitutionDetails,
      legalViewTypes: IDocumentType[]
    ) => {
      _store.update({
        institutionDetails,
        user: _store.getState<any>().user,
        caseLawDocumentTypes,
        caseDecisionTypes,
        legalViewTypes
      });
    };

    const showCategories = (id: number) => {
      const { organisation } =
        _store.getState<TOrganisationDetailsHomePresenter>();
      return _application.navigator.push({
        pathname: `/organisations/${organisation.id}/categories/${id}`
      });
    };
    const showAttachmentTypes = () => {
      const { organisation } =
        _store.getState<TOrganisationDetailsHomePresenter>();
      return _application.navigator.push({
        pathname: `/organisations/${organisation.id}/attachment-type`
      });
    };
    return {
      ...state,
      store: _store,
      loader,
      application: _application,
      translate,
      showCategories,
      loadReferenceValues,
      loadOrganisation,
      showAttachmentTypes
    };
  },
  defaultState
);

export default OrganisationDetailsHomePresenter;
